import { USER_PREFERENCES_QUERY_KEY } from "@frontend-shared/constants";
import type { IUserPreferences } from "@frontend-shared/types";
import { useQuery } from "@tanstack/react-query";
import type { i18n } from "i18next";

import { userApi } from "@/api/services";
import type { TTheme } from "@/components/ui/theme-provider";

export interface IUpdateUserPreferencesProps {
  payload: IUserPreferences;
  i18n: i18n;
  theme: TTheme;
  setTheme: (theme: TTheme) => void;
  enabled?: boolean;
}

export const updateUserPreferences = ({
  payload,
  i18n,
  theme,
  setTheme,
}: IUpdateUserPreferencesProps) => {
  if (payload.language && i18n.language !== payload.language) {
    i18n.changeLanguage(payload.language);
  }
  if (payload.theme && theme !== payload.theme) {
    setTheme(payload.theme);
  }
};

export const useUserPreferences = ({
  enabled = true,
  ...props
}: Omit<IUpdateUserPreferencesProps, "payload">) => {
  return useQuery({
    queryKey: [USER_PREFERENCES_QUERY_KEY],
    queryFn: async () => {
      const data = await userApi.getUserPreferences();
      if (data) {
        updateUserPreferences({ ...props, payload: data });
      }
      return data;
    },
    enabled,
  });
};
